import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;
import "@codetrix-studio/capacitor-google-auth";

import Google from './Google';
import Models from './Models';
import Entry from './Entry';
import Value from './Value';
import Values from './Values';

export default class Entries extends Models {

    constructor(...models) {
        super(...models);
    }
    
    async store() {
        for (let entry of this) {
            await Storage.set({
                key: `entries/${entry.form}/${entry.id}`,
                value: JSON.stringify(entry)
            });
        }
    }

    static async restore(form, search='', offset=0, limit=10) {
        let entries = new Entries();
        let keys = await Storage.keys();
        let keysFiltered = keys.keys.filter(key => key.startsWith(`entries/${form.id}`)).sort();
        for (let key of keysFiltered) {
            let found = search === '';
            const item = await Storage.get({ key: key });
            let json = JSON.parse(item.value);
            let entry = new Entry(json);
            entry.values = new Values();
            if (json.values && json.values.length > 0) {
                for (let _value of json.values) {
                    let value = new Value(_value);
                    entry.values.push(value);
                    if (value.value.toLowerCase().startsWith(search.toLowerCase())) {
                        found = true;
                    }
                }
                entry.values = entry.values.sortAsc("ordinal");
            }
            if (entries.length < offset+limit) {
                if (found) {
                    entries.push(entry);
                }
            }
            else {
                break;
            }
        }
        return entries;
    }

    static async load(form, search="", offset=0, limit=10) {
        let entries = new Entries();
        let range = `Sheet1!A${offset+2}:Z${offset+2+limit}`;
        let url = `https://sheets.googleapis.com/v4/spreadsheets/${form.key}/values/${range}`;
        let response = await Google.get(url);
        let rows = response.values;
        if (rows && rows.length > 0) {
            let fields = form.fields;
            for (let i = 0; i < rows.length; i++) { 
                let found = search === "";
                let row = rows[i];
                let entry = new Entry({
                    form: form.id,
                    key: form.key,
                    title: form.title
                });
                entry.setID(row[0], row[1]);
                entry.values = new Values();
                for (let col in row) {
                    if (col == 0) {
                        entry.user = row[col];
                    }
                    else if (col == 1) {
                        entry.created = row[col];
                    }
                    else {
                        let field = fields[col-2];
                        let value = new Value({
                            title: field.title,
                            type: field.type,
                            value: row[col],
                            ordinal: i,
                            icon: field.icon
                        });
                        entry.values.push(value);
                        if (value.value.toLowerCase().startsWith(search.toLowerCase())) {
                            found = true;
                        }
                    }
                }
                if (found) {
                    if (entries.length < limit) {
                        entries.push(entry);
                    }
                    else {
                        break;
                    }  
                }
            }
        }
        return entries;
    }

    static async pending() {
        let entries = new Entries();
        let keys = await Storage.keys();
        let filtered = keys.keys.filter(key => key.startsWith(`entries/`));
        for (let key of filtered) {
            const item = await Storage.get({ key: key });
            let json = JSON.parse(item.value);
            let entry = new Entry(json);
            if (entry.pending) {
                entry.values = new Values();
                if (json.values && json.values.length > 0) {
                    for (let _value of json.values) {
                        let value = new Value(_value);
                        entry.values.push(value);
                    }
                }
                entries.push(entry);
            }
        }
        return entries;
    }

    static async pendingCount() {
        let count = 0;
        let keys = await Storage.keys();
        for (let key of keys.keys) {
            if (key.startsWith(`entries/`)) {
                const item = await Storage.get({ key: key });
                let json = JSON.parse(item.value);
                let entry = new Entry(json);
                if (entry.pending) {
                    count = count + 1;
                }
            }
        }
        return count;
    }

}